import { Dispatch, createSlice } from "@reduxjs/toolkit";
import { TRequestStatus } from "@models/msc.model";
import couponsService from "@/services/coupons.service";
import { RootState } from "..";
import { TProductCoupon } from "@/models/products.model";

type CouponsState = {
  initialized: boolean;
  status: TRequestStatus;
  coupons: TProductCoupon[];
};

//-----THUNK FUNCTIONS-----

const initialState: CouponsState = {
  initialized: false,
  status: "IDLE",
  coupons: [],
};

const couponsSlice = createSlice({
  name: "coupons",
  initialState,
  reducers: {
    startLoading(state) {
      state.status = "PENDING";
    },
    rollBack(state, actions) {
      state.status = "IDLE";
      state.coupons = actions.payload;
    },
    gotCoupons(state, action) {
      state.coupons = action.payload;
      state.status = "IDLE";
      state.initialized = true;
    },
    couponSaved(state, action) {
      state.coupons.push(action.payload);
    },
    couponUpdated(state, action) {
      state.coupons = state.coupons.map((t) => (t.id === action.payload.id ? action.payload : t));
    },
    couponRemoved(state, action) {
      state.coupons = state.coupons.filter((t) => t.id !== action.payload);
    },
  },
});

// ----------------------------

export const getAllCoupons = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const {
    coupons: { coupons, initialized },
  } = getState();

  if (initialized) return coupons;

  dispatch(couponsSlice.actions.startLoading());
  const response = await couponsService.getCoupons();
  dispatch(couponsSlice.actions.gotCoupons(response));
  return response;
};

// ----------------------------
export const saveCoupon = (data: Omit<TProductCoupon, "created" | "updated">) => async (dispatch: Dispatch) => {
  const response = await couponsService.saveCoupon(data);
  dispatch(couponsSlice.actions.couponSaved(response));
  return response;
};

// ----------------------------
export const updateCoupon =
  (id: number, data: Omit<TProductCoupon, "created" | "updated">) => async (dispatch: Dispatch) => {
    const response = await couponsService.updateCoupon(id, data);
    dispatch(couponsSlice.actions.couponUpdated(response));
  };

// ----------------------------

export const removeCoupon = (couponId: number) => async (dispatch: Dispatch, getState: () => RootState) => {
  const { coupons } = getState().coupons;
  const couponsForRollback = structuredClone(coupons);
  dispatch(couponsSlice.actions.couponRemoved(couponId));

  try {
    await couponsService.deleteCoupon(couponId);
  } catch (error) {
    dispatch(couponsSlice.actions.rollBack(couponsForRollback));
    throw error;
  }
};

export default couponsSlice.reducer;
